import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewLoad from "@/pages/NewLoad";
import { LoadsProvider } from "@/context/LoadsContext";

function RequireAuth({ children }) {
  let authed = false;
  try { authed = localStorage.getItem("rd_authed") === "1"; } catch (_) {}
  if (!authed) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <LoadsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/new-load"
              element={
                <RequireAuth>
                  <NewLoad />
                </RequireAuth>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#1A1A1A",
              border: "2px solid rgba(255,255,255,0.18)",
              color: "#fff",
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
      </LoadsProvider>
    </div>
  );
}

export default App;
